export default __webpack_public_path__ + "static/media/homepage-player-app.c30330b1.jpg";